import { render, staticRenderFns } from "./SpiritDetails.vue?vue&type=template&id=41d522c7"
import script from "./SpiritDetails.vue?vue&type=script&lang=js"
export * from "./SpiritDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d522c7')) {
      api.createRecord('41d522c7', component.options)
    } else {
      api.reload('41d522c7', component.options)
    }
    module.hot.accept("./SpiritDetails.vue?vue&type=template&id=41d522c7", function () {
      api.rerender('41d522c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/SpiritDetails.vue"
export default component.exports